import { Select } from "@mui/material";
import { styled } from "@mui/system";

const RoundedSelect = styled(Select)(() => ({
  borderRadius: "45px",
  background: "#F1F7FA",
  width: "100%",
  display: "block",
  textAlign: "left",
  "& .MuiInputBase-input": {
    padding: "10px 15px",
    width: "100%",
    height: "40px !important",
    display: "flex",
    alignItems: "center",
    color: "#2A4876", // Set the input value color to green
    "&::placeholder": {
      color: "#151516", // Set the placeholder text color to red
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none", // Removes the border
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none", // Prevents the border when focused
  },
  "&:focus-visible": {
    outline: "none", // Ensures no outline when using keyboard navigation
  },
}));

export default RoundedSelect;
